import { PACKAGE_NAME } from "./deviceStoragePaths";

export const HTC_DEVICE_ADMIN = `${PACKAGE_NAME}/com.oculera.htcdeviceowner.AdminReceiver`;
export const HTC_RELEASE_RECEIVER = `${PACKAGE_NAME}/com.oculera.htcdeviceowner.ReleaseReceiver`;
export const HTC_RELEASE_ACTION = "com.oculera.RELEASE_DEVICE_OWNER";

export function parseDeviceOwners(listOwners: string): string[] {
  return listOwners
    .split(/\r?\n/)
    .filter((line) => /,DeviceOwner\b/.test(line))
    .map((line) => /admin=([^,\s]+)/.exec(line)?.[1])
    .filter((admin): admin is string => !!admin);
}

export function isRefusedForAccounts(setDeviceOwnerOutput: string): boolean {
  return /already some accounts/i.test(setDeviceOwnerOutput);
}

export function parseAccountTypes(dumpsysAccount: string): string[] {
  const types = [...dumpsysAccount.matchAll(/Account \{name=.*?, type=([^}]+)\}/g)].map((match) =>
    match[1].trim(),
  );
  return [...new Set(types)];
}

export function isDeviceAdminActive(dumpsysDevicePolicy: string): boolean {
  return dumpsysDevicePolicy.split(/\r?\n/).some((line) => line.trim() === `${HTC_DEVICE_ADMIN}:`);
}

export type ReleaseResult =
  | { status: "released" }
  | { status: "notDeviceOwner" }
  | { status: "failed"; reason: string }
  | { status: "noAnswer" };

export function parseReleaseResult(broadcastOutput: string): ReleaseResult {
  const data = /Broadcast completed: result=-?\d+, data="(.*)"/.exec(broadcastOutput)?.[1];
  if (data === "released") return { status: "released" };
  if (data === "not_device_owner") return { status: "notDeviceOwner" };
  if (data?.startsWith("failed")) {
    return { status: "failed", reason: data.replace(/^failed:?\s*/, "") || "unknown" };
  }
  return { status: "noAnswer" };
}
